import { useQuery } from 'react-query';

import { apiUrl } from 'src/core/utils/api';

export const useCompanyCostCenters = (companyId: string) => {
  return useQuery({
    queryKey: [companyId, 'cost-centers'],
    queryFn: async () => {
      const response = await fetch(apiUrl(`/cost-centers`, companyId), {
        method: 'GET',
        credentials: 'include',
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json',
        },
      });
      return response.json();
    },
  });
};
